import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'sonner';

export default function AdminLogin() {
  const { login, isAuthenticated } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (isAuthenticated) return <Navigate to="/admin" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await login(email, password);
      toast.success('Giris başarılı');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Giris başarısız');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="w-12 h-12 bg-[hsl(var(--gold))] rounded-xl flex items-center justify-center mx-auto mb-4">
            <span className="text-[hsl(var(--accent-foreground))] font-heading font-bold text-lg">I</span>
          </div>
          <h1 className="font-heading text-2xl font-semibold">Yönetim Paneli</h1>
          <p className="text-sm text-muted-foreground mt-1">Giriş yaparak devam edin</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4 p-6 rounded-2xl bg-card border border-border shadow-[var(--shadow-elev-1)]" data-testid="admin-login-form">
          <div>
            <label className="block text-sm font-medium mb-1.5">E-posta</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="w-full px-3 py-2.5 rounded-lg border border-input bg-background text-sm focus:outline-none focus:ring-2 focus:ring-[hsl(var(--gold))]"
              required
              data-testid="admin-login-email"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1.5">Sifre</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="w-full px-3 py-2.5 rounded-lg border border-input bg-background text-sm focus:outline-none focus:ring-2 focus:ring-[hsl(var(--gold))]"
              required
              data-testid="admin-login-password"
            />
          </div>
          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full px-4 py-2.5 rounded-lg bg-[hsl(var(--gold))] text-[hsl(var(--accent-foreground))] font-medium text-sm hover:bg-[hsl(var(--gold)/0.92)] active:scale-[0.98] transition-colors duration-200 disabled:opacity-50"
            data-testid="admin-login-submit-button"
          >
            {isSubmitting ? 'Giriş yapılıyor...' : 'Giriş Yap'}
          </button>
        </form>
      </div>
    </div>
  );
}
